// --- 广告管理 --- //

export default [
  {
    name: 'openPageManagement',
    path: '/platformManagement/adManagement/openPageManagement',
    meta: { title: '开屏页广告管理' },
    component: require('business/platformManagement/adManagement/openPageManagement/list.vue').default
  },
  {
    name: 'slideshowManagement',
    path: '/platformManagement/adManagement/slideshowManagement',
    meta: { title: '轮播图管理' },
    component: require('business/platformManagement/adManagement/slideshowManagement/list.vue').default
  }
]
